import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'
import { md3 } from 'vuetify/blueprints'

import { createVuetify } from 'vuetify'

const haskoningLight = {
  dark: false,
  colors: {
    background: '#FBF2E2',
    surface: '#FFFFFF',
    primary: '#002D4F',
    secondary: '#002D4F',
    highlight: '#CCECEE',
    success: '#0F7C86',
    warning: '#8C6500',
    error: '#B3261E',
    info: '#5D7685',
    canvas: '#FBF2E2',
    panel: '#FFFFFF',
    border: '#D9D9D9'
  }
}

export default createVuetify({
  blueprint: md3,
  theme: {
    defaultTheme: 'haskoningLight',
    themes: {
      haskoningLight: haskoningLight
    }
  },
  defaults: {
    VTextField: {
      variant: 'filled',
      color: 'primary',
      hideDetails: 'auto'
    },
    VSelect: {
      variant: 'filled',
      color: 'primary',
      hideDetails: 'auto'
    },
    VTextarea: {
      variant: 'filled',
      color: 'primary',
      hideDetails: 'auto'
    },
    VCard: {
      rounded: 'xl',
      elevation: 0,
      style: [{ borderColor: '#D9D9D9', backgroundColor: '#FFFFFF' }]
    },
    VBtn: {
      style: [{ textTransform: 'none' }]
    }
  }
})
